import {
  getSystemLogsFunction,
  type GetSystemLogsData,
  type GetSystemLogsResponse,
} from "../firebase/functions";

export class SystemLogsService {
  /**
   * Get system logs using cloud function
   */
  static async getSystemLogs(
    data: GetSystemLogsData
  ): Promise<GetSystemLogsResponse> {
    try {
      const result = await getSystemLogsFunction(data);
      const response = result.data as GetSystemLogsResponse;

      if (!response.success) {
        throw new Error("Failed to retrieve system logs");
      }

      return response;
    } catch (error: any) {
      // Error getting system logs - rethrow with proper error message
      throw new Error(error.message || "Failed to retrieve system logs");
    }
  }
}
